import Header from 'components/header'
import SideBar from 'components/siderbar'
import { NotificationContext } from 'context/notification_context'
import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router'
import { Service } from 'services/api'
import Renderif from 'utils/renderif'

export default function NuevaDinamicaView() {

    const location = useLocation();

    const _activity = location.state?.activity


    const navigate = useNavigate()
    const {notify} = useContext(NotificationContext)
    const [file, setFile] = useState(null)

    const [state, setState] = useState({
        rewards:[],
        step:0,
        start_date:"",
        start_time:"",
        end_date:"",
        end_time:"",
        dinamica:{
            name:"",
            type:0,
            image:null,
            idReward:"",
            stock_reward:"",
            idSponsor:null,
            expiration:"2025-01-01T06:00:00.000Z"
        }
    })

    useEffect(()=>{
        init()
        return () => {}
    },[])

    const init = async () => {

        let _rewards = await Service('GET', `reward`)
        state.rewards = _rewards.data.data;
        setState({...state})

        if(_activity !== undefined){
    
            state.end_date = _activity?.expiration?.split('T')[0]
            state.end_time = _activity?.expiration?.split('T')[1].split('.')[0]
            console.log(state.end_time)
            state.dinamica.name = _activity.name
            state.dinamica.idReward = _activity.idReward
            state.dinamica.reward_stock = _activity.reward_stock
            // state.dinamica.expiration = _activity.expiration
            state.dinamica.image = _activity.image
            state.step = 0;
            setState({...state})
        }
        

    }

    const onCreateDimanica = async () => {

      
        // if(file === null){
        //     console.log("FOTO REQUERIDA")
        //     return
        // }

        // if(state.end_date === "" || state.end_time === ""){
        //     console.log("EXPIRATION REQUERIDA")
        //     return
        // }

        let expiration = `${state.end_date}T${state.end_time}:00.000Z`
       
        let _upload = { data: _activity !== undefined ? _activity.image : "" };

        if(file !== null){
            _upload = await upLoad()
        }
        let body = {
            ...state.dinamica
        }
        body.image = _upload.data

        body.expiration = expiration;
        body.idReward = parseInt(body.idReward)
        body.reward_stock = parseInt(body.reward_stock)
   
        let _create_activity;
        if(_activity !== undefined){
            _create_activity = await Service('PATCH', `activity/${_activity.id}`, body)
            if(_create_activity.status === 200){
                notify({title:"Nueva dinámica", message:"Dinamica creada exitosamente.", type:'success'})
                navigate(`/question/${_activity.id}`)
            }else{
                notify({title:"Dinámica", message:"", type:'Error'})
            }
        }else{
            _create_activity = await Service('POST', 'activity', body)
            if(_create_activity.status === 201){
                notify({title:"Nueva dinámica", message:"Dinamica creada exitosamente.", type:'success'})
                navigate(`/question/${_create_activity.data.data.id}`)
            }else{
                notify({title:"Nueva dinámica", message:"", type:'Error'})
            }
        }
    


      

       
        

    } 

    const upLoad = async () => {
        console.log(file)
        let body = new FormData();
        body.append("file", file);
        return await Service('POSTMEDIA', `upload`, body )
        
        // return await Service('POSTMEDIA', `document/upload/${type}`, body )

        // let _upload = await Service('POSTMEDIA', 'upload') 
    } 
  return (
    <div className='container-fluid d-flex p-0'>

        <SideBar></SideBar>

        <div className='col overflow-auto bg-primary'>

            
             <Header title="Nueva Dinámica" subtitle="Dinámica" />


            <div className='container-md d-flex align-items-center mt-5'>

                <div className={`step ${state.step >= 0 ? 'step--active':''}`} onClick={()=>{setState({...state, step:0})}}>1</div>
                <div className={`step-line ${state.step >= 1 ? 'step-line--active':''}`}></div>

                <div className={`step ${state.step >= 1 ? 'step--active':''}`} onClick={()=>{setState({...state, step:1})}}>2</div>
                <div className={`step-line ${state.step >= 2  ? 'step-line--active':''}`}></div>

                <div className={`step ${state.step >= 2 ? 'step--active':''}`} onClick={()=>{setState({...state, step:2})}}>3</div>
                <div className={`step-line ${state.step >= 3  ? 'step-line--active':''}`}></div>

                <div className={`step ${state.step >= 3 ? 'step--active':''}`} onClick={()=>{setState({...state, step:3})}}>4</div>

                
            </div>


            <Renderif isTrue={state.step === 0}>
                <div className='container-md'>

                   <div className='mt-5'>
                        <div className='text-white f-32 bold'>Nombre</div>
                        <div className='d-flex align-items-center mt-3 bg-white-alpha-05 overflow-hidden r-10'>

                            <div className='thumbnail--md' style={{backgroundImage:  ` ${_activity !== undefined ? 'url('+_activity.image+')' : 'url(/images/dinamica_name.jpeg)' }`}}></div>

                           <div className='col px-3'>
                            <div className='f-16 bold'>Asígnale un nombre a tu dinámica</div>
                            <input className='form-control mt-2' value={state.dinamica.name} onChange={(evt)=>{
                                state.dinamica.name = evt.currentTarget.value
                                setState({...state})
                            }}></input>
                           </div>
                        </div>
                   </div>

                    <div className='d-flex mt-3'>
                        <div className='col'></div>
                        <Button variant="primary" onClick={() => {
                           setState({...state, step:1})
                        }}>
                            Siguiente
                        </Button>
                    </div>
                </div>
            </Renderif>

            <Renderif isTrue={state.step === 1}>
                <div className='container-md'>
                    
                    <div className='mt-5'>
                        <div className='text-white f-32 bold'>Imágen</div>

                        <div className='d-flex align-items-center mt-3 bg-white-alpha-05 overflow-hidden r-10'>


                            <div className='thumbnail--md' style={{backgroundImage:  ` ${_activity !== undefined ? 'url('+_activity.image+')' : 'url(/images/dinamica_name.jpeg)' }`}}></div>

                            <div className='col px-3'>
                            <div className='f-16 bold my-1'>Selecciona una imagen apropiado para esta dinámica</div>
                            <input type='file' className='form-control' onChange={(evt)=>{
                            setFile(evt.currentTarget.files[0])
                        }}></input>
                            </div>
                        </div>
                    </div>

         
                     <div className='d-flex mt-3'>
                        <div className='col'></div>
                        <Button variant="primary" onClick={() => {
                           setState({...state, step:2})
                        }}>
                            Siguiente
                        </Button>
                    </div>
                </div>
            </Renderif>

            <Renderif isTrue={state.step === 2}>


             <div className='container-md'>
                    
                    <div className='mt-5'>
                        <div className='text-white f-32 bold'>Recompensa</div>

                        <div className='d-flex align-items-center mt-3 bg-white-alpha-05 overflow-hidden r-10'>

                            <div className='thumbnail--md' style={{backgroundImage: 'url(/images/dinamica_name.jpeg)'}}></div>

                            <div className='col px-3'>

                            <div className='f-16 bold my-1'>Selecciona una recompensa para esta dinámica</div>
                            <select value={state.dinamica.idReward} onChange={(evt)=>{
                                state.dinamica.idReward = evt.currentTarget.value;
                                setState({...state})
                            }} className='form-control'>
                                <option value="">Selccionar</option>
                                {
                                    state.rewards.map((reward, i) => {
                                        return (
                                            <option key={i} value={reward.id}>{reward.name}</option>
                                        )
                                    })
                                }
                          
                             
                            </select>

                     
                            </div>

                            <div className='col px-3'>
                                
                            
    
                                <div className='f-16 bold my-1'>Número de recompensas</div>
                                <select value={state.dinamica.reward_stock} onChange={(evt)=>{
                                    state.dinamica.reward_stock = evt.currentTarget.value
                                    setState({...state})
                                }} className='form-control'>
                                    <option value="5">Seleccionar</option>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="1000">1000</option>
                                    <option value="5000">5000</option>
                                    <option value="10000">10000</option>
                                    
                                </select>
                                </div>
                        </div>
                    </div>

         
                     <div className='d-flex mt-3'>
                        <div className='col'></div>
                        <Button variant="primary" onClick={() => {
                           setState({...state, step:3})
                        }}>
                            Siguiente
                        </Button>
                    </div>
                </div>

            </Renderif>
            <Renderif isTrue={state.step === 3}>

                <div className='container-md'>
                    
                    <div className='mt-5'>
                        <div className='text-white f-32 bold'>Vencimiento</div>

                        <div className='d-flex align-items-center mt-3 bg-white-alpha-05 overflow-hidden r-10'>

                            <div className='thumbnail--xl' style={{backgroundImage: 'url(/images/dinamica_name.jpeg)'}}></div>

                            <div className='col px-3'>
                            <div className='f-16 bold my-1'>Selecciona la fecha y hora de vencimiento para esta dinámica</div>
                            <div className='d-flex'>
                                {/* <div className='col pe-2'>
                                    <div className='f-14 bold'>Inicio</div>
                                    <input className='form-control' type='date' value={state.start_date} onChange={(evt)=>{
                                        state.start_date = evt.currentTarget.value
                                        setState({...state})
                                        console.log(evt.currentTarget.value)
                                    }}></input>
                                    <input className='form-control mt-3' type='time' value={state.state_time} onChange={(evt)=>{
                                          state.start_time = evt.currentTarget.value
                                          setState({...state})
                                          console.log(evt.currentTarget.value)
                                    }}></input>

                                </div> */}
                                <div className='col'>
                                    
                                    <input className='form-control' type='date' value={state.end_date} onChange={(evt)=>{
                                        state.end_date = evt.currentTarget.value
                                        setState({...state})
                                        console.log(evt.currentTarget.value)
                                    }}></input>
                                    <input className='form-control mt-3' type='time' value={state.end_time} onChange={(evt)=>{
                                        state.end_time = evt.currentTarget.value
                                        setState({...state})
                                        console.log(evt.currentTarget.value)
                                    }}></input>

                                </div>
                            </div>
                            </div>
                        </div>
                    </div>

         
                     <div className='d-flex mt-3'>
                        <div className='col'></div>
                        <Button variant="primary" onClick={() => {
                             onCreateDimanica()
                        }}>
                            Crear Dinámica
                        </Button>
                    </div>
                </div>

           

            </Renderif>

            <div className='d-none'>
                <div>Juego</div>
                <div>Tipo de Juego</div>
                <select className='form-control'>
                    <option>Seleccionar</option>
                    <option>Quiz</option>
                    <option disabled>Mini game</option>
                </select>

              <div className='d-flex align-items-center mt-2'>
                <select className='form-control'>
                        <option>Seleccionar Quiz</option>
                        <option>Recompensa 1</option>
                        <option>Recompensa 2</option>
                    </select>
                    <div className='mx-3'>Ò</div>
                    <div className=''>
                        <Button variant="primary" className='responsive-button' onClick={() => {
                            navigate('/quiestion/1')
                        }}>
                            Crear Quiz
                        </Button>
                    </div>
              </div>
              <Button variant="primary" className='responsive-button' onClick={() => {
                onCreateDimanica()
              }}>
                    Crear Dinámica
                </Button>

            </div>

            

        </div>

    </div>
  )
}
